import React from "react";
import styles from "./BussinessButton.module.css";

function BussinessButton() {

  const handleOnClick = (e) => {
    e.preventDefault();
    // Enviando un mensaje al componente padre para que cambie la URL del iframe
    window.parent.postMessage({
      action: "changeIframeSrc",
      url: "https://viba720.mobileinsight.com/?qrCodeId=QRC-3986f814-65aa-465b-9997-2a7f6b3da2a9"
    }, "*");
  };

  return (
    <div className={styles.bussinessWrapper}>
      <div className={styles.containerBussinessText}>
        <p>
          Ya eres cliente de residencial y quieres contratar un plan negocios
          adicional.
        </p>
      </div>

      <div className={styles.containerBussinessImage}>
        <div>
          <div onClick={handleOnClick}><img
            className={styles.businessImg}
            src={`${process.env.REACT_APP_BASE_URL_ICONS}negocios.png`}
            alt="Negocios"
          />
          </div>
        </div>
        <div className={styles.wrapperRHandImage}>
          <img
            className={`${styles.rHandImage} ${styles.shakingHand}`}
            src={`${process.env.REACT_APP_BASE_URL_ICONS}r-hand.png`}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default BussinessButton;
